'use client';
var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/components/atoms/skeleton.tsx
import { cn } from "@base/utils/cn";
import { jsx, jsxs } from "react/jsx-runtime";
function Skeleton({ className, ...props }) {
  return /* @__PURE__ */ jsx("div", { className: cn("motion-safe:animate-pulse r\
ounded-md bg-muted", className), ...props });
}
__name(Skeleton, "Skeleton");
var SKELETON_ROW_DEFAULT_COLUMNS = 4;
function SkeletonRow({
  columns = SKELETON_ROW_DEFAULT_COLUMNS,
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx("div", { className: cn("flex items-center gap-3 py-\
2", className), ...props, children: Array.from({ length: columns }, (_, idx) => `\
col-${idx}`).map((key) => /* @__PURE__ */ jsx(Skeleton, { className: "h-4 flex-1" },
  key)) });
}
__name(SkeletonRow, "SkeletonRow");
var SKELETON_CARD_DEFAULT_LINES = 3;
function SkeletonCard({
  lines = SKELETON_CARD_DEFAULT_LINES,
  className,
  ...props
}) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn("flex flex-col gap-2 rounded-lg border border-border/40 p-4",
      className),
      ...props,
      children: [
        /* @__PURE__ */ jsx(Skeleton, { className: "h-5 w-1/3" }),
        Array.from({ length: lines }, (_, idx) => `line-${idx}`).map((key) => /* @__PURE__ */ jsx(
        Skeleton, { className: "h-3 w-full" }, key))
      ]
    }
  );
}
__name(SkeletonCard, "SkeletonCard");
export {
  Skeleton,
  SkeletonCard,
  SkeletonRow
};
